import { useState } from "react";
import { useTranslation } from "react-i18next";
import Logo from "../images/img.png";
import Icon from "./Icon";
import Modal from "./Modal";
import { LEGAL_LINKS, NAV, SITE } from "../data/site";
import { PRODUCTS } from "../data/products";
import { useL } from "../lib/useLang";
import { isJoinPath, scrollToSection } from "../lib/navigation";

export default function Footer() {
  const { t } = useTranslation();
  const L = useL();
  const [legal, setLegal] = useState(null);
  const onJoinPage = isJoinPath();

  const go = (id) => (event) => {
    if (onJoinPage || !document.getElementById(id)) return;

    event.preventDefault();
    scrollToSection(id);
  };

  const navHref = (id) => (id === "unete" ? "/unete" : `/#${id}`);

  const goToNavItem = (id) => (event) => {
    if (id === "unete" || onJoinPage || !document.getElementById(id)) return;

    event.preventDefault();
    scrollToSection(id);
  };

  const year = new Date().getFullYear();

  return (
    <footer className="fsg-footer">
      <div className="fsg-container">
        <div className="fsg-footer__top">
          <div className="fsg-footer__brand">
            <img src={Logo} alt={SITE.name} />
            <p>{t("footer.about")}</p>
            <div className="fsg-social">
              <a
                href={SITE.social.facebook}
                target="_blank"
                rel="noreferrer"
                aria-label="Facebook"
              >
                <Icon name="facebook" />
              </a>
              <a
                href={SITE.social.instagram}
                target="_blank"
                rel="noreferrer"
                aria-label="Instagram"
              >
                <Icon name="instagram" />
              </a>
              <a
                href={`https://wa.me/${SITE.whatsapp}`}
                target="_blank"
                rel="noreferrer"
                aria-label="WhatsApp"
              >
                <Icon name="whatsapp" />
              </a>
            </div>
          </div>

          <div className="fsg-footer__col">
            <h4>{t("footer.explore")}</h4>
            <ul>
              {NAV.map((item) => (
                <li key={item.id}>
                  <a href={navHref(item.id)} onClick={goToNavItem(item.id)}>
                    {L(item.label)}
                  </a>
                </li>
              ))}
              <li>
                <a href="/#faq" onClick={go("faq")}>
                  {t("faq.eyebrow")}
                </a>
              </li>
            </ul>
          </div>

          <div className="fsg-footer__col">
            <h4>{t("footer.products")}</h4>
            <ul>
              {PRODUCTS.map((product) => (
                <li key={product.id}>
                  <a href="/#productos" onClick={go("productos")}>
                    {L(product.name)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="fsg-footer__col">
            <h4>{t("footer.contact")}</h4>
            <ul className="fsg-footer__contact">
              <li>
                <Icon name="phone" />
                <a href={`tel:${SITE.phone}`}>{SITE.phoneDisplay}</a>
              </li>
              <li>
                <Icon name="whatsapp" />
                <a
                  href={`https://wa.me/${SITE.whatsapp}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {SITE.whatsappDisplay}
                </a>
              </li>
              <li>
                <Icon name="mail" />
                <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
              </li>
              <li>
                <Icon name="pin" />
                <span>{SITE.address.full}</span>
              </li>
              <li>
                <Icon name="clock" />
                <span>{L(SITE.hours)}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="fsg-footer__legal">
          <span>
            © {year} {SITE.name}. {t("footer.rights")}
          </span>
          <ul>
            {LEGAL_LINKS.map((item) => (
              <li key={item.id}>
                <button type="button" onClick={() => setLegal(item.id)}>
                  {L(item.label)}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <p className="fsg-footer__disclaimer">{t("footer.disclaimer")}</p>
      </div>

      <Modal
        open={Boolean(legal)}
        onClose={() => setLegal(null)}
        title={legal ? t(`legal.${legal}.title`) : ""}
      >
        <div className="fsg-legal">
          {legal &&
            t(`legal.${legal}.body`)
              .split("\n\n")
              .map((paragraph, index) => <p key={index}>{paragraph}</p>)}
        </div>
      </Modal>
    </footer>
  );
}
